import styled, { useTheme } from 'styled-components/native'
import Icon from 'APP/Converse/Icon'
import Typography from '../Typography'

const Wrapper = styled.TouchableOpacity`
  display: flex;
  flex-direction: row;
  margin-horizontal: ${({ theme }) => theme.metrics.baseMargin}px;
  margin-bottom: ${({ theme }) => theme.metrics.baseMargin}px;
`

const FakeInput = styled.View`
  border: 1px solid ${({ theme }) => theme.colors.elementsBorder};
  border-radius: 100px;
  height: 40px;
  flex: 1;
  flex-direction: row;
  align-items: center;
`

const StyledIcon = styled(Icon)`
  padding-horizontal: ${({ theme }) => theme.metrics.baseMargin / 2}px;
`

const SemanticSearchTrigger = ({
  handleOpen,
  placeholder = '',
}: {
  handleOpen: () => void
  placeholder?: string
}) => {
  const theme = useTheme()

  return (
    <Wrapper onPress={handleOpen} testID="OPEN_SEMANTIC_SEARCH">
      <FakeInput>
        <StyledIcon
          src="magnify"
          variant="material"
          color="accent"
          size={theme.metrics.icon.small}
        />
        <Typography>{placeholder}</Typography>
      </FakeInput>
    </Wrapper>
  )
}

export default SemanticSearchTrigger
